module.exports = __webpack_public_path__ + "static/media/falsemirror-grid.932e096c.png";